<template>
  <div class="album-container">
    <template
      v-for="album in music.albums"
    >
      <album-card
        :album="album"
        :key="album.title + '-card'"
        @click="selectAlbum(album)"
        :class="{ current: isCurrentAlbum(album) }"
      />
      {{ album.value }}
      <album-listing
        v-if="isCurrentAlbum(album)"
        :album="album"
        :key="album.title + '-listing'"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { musicStore } from '@/store';
import { AlbumEntry, MusicStoreState } from '@/store/MusicStore';
import { computed, reactive, toRefs, toRaw } from 'vue';
import AlbumCard from '@/components/AlbumCard.vue';
import AlbumListing from '@/components/AlbumListing.vue';

export default {
  setup() {
    let music: MusicStoreState;
    return {
      music: (music = musicStore.getState()),
      ...useAlbumSelection(),
      someAlbums: computed(() => Object.values(music.albums).slice(0, 5))
    };
  },
  components: {
    AlbumCard,
    AlbumListing
  }
};

function useAlbumSelection() {
  const state = reactive({
    currentAlbum: null as AlbumEntry
  });

  function selectAlbum(album: AlbumEntry): void {
    state.currentAlbum = album;
  }

  function isCurrentAlbum(album: AlbumEntry): boolean {
    return toRaw(state.currentAlbum) === toRaw(album);
  }

  return {
    ...toRefs(state),
    selectAlbum,
    isCurrentAlbum
  };
}
</script>

<style lang="scss" scoped>
.album-container {

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-auto-rows: minmax(1fr, max-content);
  grid-auto-flow: row dense;

  &::before {
    content: '';
    width: 0;
    padding-bottom: 100%;
    grid-area: 1 / 1 / 1 / 1;
  }

  :first-child {
    grid-area: 1 / 1 / 1 / 1;
  }

  .album {

    margin: 10px;

    &:after {
      content: '';
      padding-bottom: 100%;
    }
  }

  .album-listing {
    grid-column: 1 / -1;
    border: 1px solid black;
    margin: 10px;

    min-height: 8rem;
  }
}
</style>
